import { SubLayout } from "@/containers/layout/LandingLayout";

const StillHaveQuestions = (): JSX.Element => {
  return (
    <SubLayout allowOverflow>
      <section className="relative z-30 flex flex-col items-center justify-center w-full mx-auto text-white mt-9 md:mt-5 md:-top-5 xl:-top-6 py-9 px-7 md:h-40 xl:h-60 rounded-2xl p-14 bg-landing-cherry">
        <h2 className="text-3xl font-bold text-center xl:text-5xl max-w-[360px] md:max-w-fit">
          Still have questions?
        </h2>

        <div className="flex flex-col items-center justify-center text-center md:mt-5 md:flex-row">
          <p className="my-6 font-serif text-xl font-normal md:my-auto xl:text-2xl whitespace-nowrap">
            Get in touch:{" "}
            <span className="underline">
              {" "}
              <a href="mailto:hello@keyzy.com" target="_blank" rel="noreferrer">
                hello@keyzy.com
              </a>
            </span>
          </p>
        </div>
      </section>
    </SubLayout>
  );
};

export default StillHaveQuestions;
